var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-panel',{attrs:{"stretch":_vm.$attrs.stretch,"min-width":250,"max-width":1000,"min-height":60,"max-height":240}},[_c('iot-gateway-content',_vm._b({},'iot-gateway-content',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }